import { TargetingType } from '../../config.js'
import { TargetingTypeSmall } from '../badge/TargetingTypeSmall.js'
import React from 'react'

export const CampaignOrAdGroupBadges = ({ data }: any) => {
    let targeting_type = data.targeting_type
    if (data.targeting_settings === 'AUTO') {
        targeting_type = TargetingType.Auto
    } else if (data.targeting_settings === 'MANUAL') {
        targeting_type = TargetingType.Manual
    }

    return <TargetingTypeSmall className="mr-2" {...data} targeting_type={targeting_type} />
}
